class CartRemoveButton extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', (event) => {
			event.preventDefault();
			const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
			cartItems.updateQuantity(this.dataset.index, 0).then(() => {
				cartItems.checkGiftWithPurchase();
			});
		});
	}
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
	constructor() {
		super();

		this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

		this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
			.reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

		this.debouncedOnChange = debounce((event) => {
			this.onChange(event);
		}, 300);

		this.addEventListener('change', this.debouncedOnChange.bind(this));

		this.checkGiftWithPurchase();
	}

	checkGiftWithPurchase() {
		if (!window.CartGiftWithPurchase) {
			return false;
		}

		fetch(`${routes.cart_url}`, {
			...fetchConfig()
		})
			.then((response) => response.json())
			.then(async (cart) => {
				await window.CartGiftWithPurchase.manageGiftWithPurchase(cart);
			});
	}

	async onChange(event) {
		await this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
		this.checkGiftWithPurchase();
	}

	getSectionsToRender() {
		if(window.is_cart_page == 'cart_page'){

			return [ 
				{ 
					id: 'main-cart-items', 
					section: document.getElementById('main-cart-items').dataset.id, 
					selector: '.js-contents' 
				}, 
				{ 
					id: 'cart-icon-bubble', 
					section: 'cart-icon-bubble', 
					selector: '.shopify-section' 
				}, 
				{ 
					id: 'cart-live-region-text', 
					section: 'cart-live-region-text', 
					selector: '.shopify-section' 
				}, 
				{ 
					id: 'main-cart-footer', 
					section: document.getElementById('main-cart-footer').dataset.id, 
					selector: '.full-cart-page' 
				}, 
				{ 
					id: 'cart-item-count', 
					section: 'ajax-cart', 
					selector: '#cart-item-count' 
				} 
			]; 

		}else{

			return [
				{
					id: 'main-cart-items',
					section: document.getElementById('main-cart-items').dataset.id,
					selector: '.js-contents'
				},
				{
					id: 'cart-icon-bubble',
					section: 'cart-icon-bubble',
					selector: '.shopify-section'
				},
				{
					id: 'cart-live-region-text',
					section: 'cart-live-region-text',
					selector: '.shopify-section'
				},
				{
					id: 'main-cart-footer',
					section: document.getElementById('main-cart-footer').dataset.id,
					selector: '.cart__blocks.js-contents'
				},
				{
					id: 'cart-item-count',
					section: document.getElementById('cart-item-count')?.dataset?.id || 'default-cart-item-count',
					selector:'.cart__items-count'
				},
				
				{
					id:"cart-threshold-goal",
					section: document.getElementById('cart-threshold-goal')?.dataset?.id || 'default-cart-threshold-goal',
					selector:".cart__threshold-goal"
				}
			];

		}
		
	}

	updateCartCount() {
		const cartCountBubble = document.querySelector(".cart-count-bubble");

		if (!cartCountBubble) {
			return false;
		}

		fetch('/cart.js', {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					'Accept': `application/json`
				}
			})
			.then((response) => response.json())
			.then((response) => {
				if (response.status) {
					this.handleErrorMessage(response.description);
					return;
				}
				cartCountBubble.classList.remove('hidden');
				cartCountBubble.querySelector('[aria-hidden="true"]').innerText = response.item_count;
			})
			.catch((e) => {
				console.error(e);
			});
	}

	async updateQuantity(line, quantity, name) {
		this.enableLoading(line);
		const body = JSON.stringify({
			line,
			quantity,
			sections: this.getSectionsToRender().map((section) => section.section),
			sections_url: window.location.pathname
		});

		await fetch(`${routes.cart_change_url}`, {
				...fetchConfig(),
				...{
					body
				}
			})
			.then((response) => {
				return response.text();
			})
			.then((state) => {
				const parsedState = JSON.parse(state);
				this.classList.toggle('is-empty', parsedState.item_count === 0);
				const cartDrawerWrapper = document.querySelector('cart-drawer');
				const cartFooter = document.getElementById('main-cart-footer');

				if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
				if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

				this.getSectionsToRender().forEach((section => {

					const elementToReplace =
						document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
				
						elementToReplace.innerHTML =
						this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
					

					}));

				this.updateLiveRegions(line, parsedState.item_count);
				const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
				if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
					cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
				} else if (parsedState.item_count === 0 && cartDrawerWrapper) {
					trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
				} else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
					trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
				}
				this.disableLoading();
			}).catch(() => {
				this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
				const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
				errors.value = window.cartStrings.error;
				this.disableLoading();
			});

		const giftWrap = document.querySelector('gift-wrap');

		if (giftWrap) {
			giftWrap.middleware();
		}
	}

	updateLiveRegions(line, itemCount) {
		if (this.currentItemCount === itemCount) {
			const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
			const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

			lineItemError
				.querySelector('.cart-item__error-text')
				.innerHTML = window.cartStrings.quantityError.replace(
					'[quantity]',
					quantityElement.value
				);
		}

		this.currentItemCount = itemCount;
		this.lineItemStatusElement.setAttribute('aria-hidden', true);

		const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
		cartStatus.setAttribute('aria-hidden', false);

		setTimeout(() => {
			cartStatus.setAttribute('aria-hidden', true);
		}, 1000);
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser()
			.parseFromString(html, 'text/html')
			.querySelector(selector).innerHTML;
	}

	enableLoading(line) {
		const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
		mainCartItems.classList.add('cart__items--disabled');

		const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
		const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

		[...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

		document.activeElement.blur();
		this.lineItemStatusElement.setAttribute('aria-hidden', false);
	}

	disableLoading() {
		const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
		mainCartItems.classList.remove('cart__items--disabled');
	}
}

customElements.define('cart-items', CartItems);

class GiftWrap extends HTMLElement {
	constructor() {
		super();
		this.textAreaWrapper = this.querySelector('.js-gift-message');
		this.textArea = this.querySelector('.js-gift-textarea');
		this.checkbox = this.querySelector('.js-gift-wrap-checkbox');

		this.giftWrapId = this.dataset.giftwrapId;

		this.debouncedOnGiftWrapMessageChange = debounce(this.onGiftWrapMessageChange.bind(this), 300);

		this.cartItems = document.querySelector('cart-items');

		this.attachListeners();

		this.middleware();
	}

	noteFormatter(note) {
		return note.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '').replace(/(\r\n|\n|\r)/gm, '');
	}

	async onGiftWrapMessageChange() {
		this.textArea.value = this.noteFormatter(this.textArea.value);

		const cartGiftWrapItem = this.cartItems.querySelector('.js-cart-item-gift-wrap');

		await this.updateGiftWrapMessage(cartGiftWrapItem, this.textArea.value);
	}

	async updateGiftWrapMessage(giftWrapItem = this.cartItems.querySelector('.js-cart-item-gift-wrap'), giftWrapMessage = "") {
		if (!giftWrapItem) {
			return null;
		}

		const index = giftWrapItem.dataset.giftWrapIndex;

		const body = JSON.stringify({
			line: index,
			properties: {
				"Gift Message": giftWrapMessage
			}
		});

		return await fetch(`${window.Shopify.routes.root}cart/change.js`, {
			...fetchConfig(),
			...{
				body
			}
		});
	}

	async onCheckboxChange() {
		const enabled = this.checkbox.checked;

		this.textAreaWrapper.classList.toggle('hidden', !enabled);

		const cartGiftWrapItem = this.cartItems.querySelector('.js-cart-item-gift-wrap');

		if (enabled) {
			if (!cartGiftWrapItem) {
				const formData = {
					items: [{
						id: this.giftWrapId,
						quantity: 1
					}],
					sections: this.cartItems.getSectionsToRender().map((section) => section.section),
					sections_url: window.location.pathname
				};

				fetch(`${window.Shopify.routes.root}cart/add.js`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify(formData)
				}).then((response) => {
					return response.json();
				}).then((data) => {
					
					this.cartItems.getSectionsToRender().forEach((section => {
						const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
						elementToReplace.innerHTML = this.cartItems.getSectionInnerHTML(data.sections[section.section], section.selector);
					}));
				}).catch((error) => {
					console.error('Error:', error);
				});

				await this.middleware();
			}

			return null;
		}

		await this.removeGiftWrap(cartGiftWrapItem);
	}

	async removeGiftWrap(cartGiftWrapItem = this.cartItems.querySelector('.js-cart-item-gift-wrap')) {
		this.textArea.value = '';

		if (!cartGiftWrapItem) {
			return null;
		}

		const index = cartGiftWrapItem.dataset.giftWrapIndex;

		await this.cartItems.updateQuantity(index, 0);
	}

	async middleware() {
		const wrapper = this.cartItems.querySelector('.js-cart-items-wrapper');

		const itemCountWithoutGiftWrap = wrapper ? +wrapper.dataset.itemCountWithoutGiftWrap : 0;

		if (Number.isNaN(itemCountWithoutGiftWrap)) {
			return null;
		}

		if (itemCountWithoutGiftWrap <= 5 && itemCountWithoutGiftWrap > 0) {
			this.classList.remove('hidden');

			return null;
		}

		this.checkbox.checked = false;
		this.textAreaWrapper.classList.add('hidden');
		this.classList.add('hidden');

		await this.removeGiftWrap();
	}

	attachListeners() {
		this.textArea.addEventListener('input', this.debouncedOnGiftWrapMessageChange);

		this.checkbox.addEventListener('change', this.onCheckboxChange.bind(this));
	}
}

customElements.define('gift-wrap', GiftWrap);

if (!customElements.get('cart-note')) {
	customElements.define('cart-note', class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener('change', debounce((event) => {
				const body = JSON.stringify({
					note: event.target.value
				});
				fetch(`${routes.cart_update_url}`, {
					...fetchConfig(),
					...{
						body
					}
				});
			}, 300));
		}
	});
}
